module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-sm carrier-account\"> <div class=\"modal-content\"> <form> <section class=\"modal-body\"> <p>Choose the two small deposit amounts in cents from your bank account for verification.</p> <div class=\"row\"> <div class=\"col-6\"> <select id=\"verification_amount_1\" class=\"verification_amount form-control\"> ")
    ;  for(var i = 1; i <= 99; i++){ 
    ; __append(" <option value=\"")
    ; __append(escapeFn( i ))
    ; __append("\">")
    ; __append(escapeFn( i ))
    ; __append("</option> ")
    ;  } 
    ; __append(" </select> </div> <div class=\"col-6\"> <select id=\"verification_amount_2\" class=\"verification_amount form-control\"> ")
    ;  for(var i = 1; i <= 99; i++){ 
    ; __append(" <option value=\"")
    ; __append(escapeFn( i ))
    ; __append("\">")
    ; __append(escapeFn( i ))
    ; __append("</option> ")
    ;  } 
    ; __append(" </select> </div> </div> </section> <section class=\"modal-footer\"> <button class=\"btn btn-secondary verify_amounts\" type=\"submit\">Verify</button> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/bank_account_verification_modal.ejs
// module id = 1248
// module chunks = 1